module.exports = __webpack_public_path__ + "img/Checkbox selected Icon - charcoal.ab24328c.svg";